import { render, staticRenderFns } from "./NotificationContactRequestDeclined.vue?vue&type=template&id=6b2cdeeb&scoped=true&lang=pug&"
import script from "./NotificationContactRequestDeclined.vue?vue&type=script&lang=js&"
export * from "./NotificationContactRequestDeclined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cdeeb",
  null
  
)

export default component.exports